import Api from './ApiService'

export default {
    loginADM(credentials) {
        return Api().post('adm/login', credentials);
    },
}